import { useState } from 'react'

import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

import { PDPProductSizeGuide } from './SizeGuide.types'

const getDefaultUnitIndex = (pdpProductSizeGuides: PDPProductSizeGuide[], tabName: string): number => {
  const selectedGuide = pdpProductSizeGuides.find(guide => guide.tabName === tabName)
  const sections = selectedGuide?.productSizeGuides?.[0]?.sizeChart?.sections ?? []
  const defaultIndex = sections.findIndex(section => section?.isDefault === true)
  return defaultIndex >= 0 ? defaultIndex : 0
}

const useSizeGuide = ({ pdpProductSizeGuides }: { pdpProductSizeGuides: PDPProductSizeGuide[] }) => {
  const localeConfig = useStatsigDynamicLocaleConfig()
  // NOTE: `displayLocalisedReviewSize` doubles as the gate for localised size-guide
  // defaults (e.g. UK metric/imperial default derived from `isDefault` on sizeChart
  // sections). If US/CA ever need this size-guide behaviour independently, introduce
  // a dedicated flag (e.g. `useLocalisedSizeDefaults`) and update this hook.
  const showLocalisedReviewUI = Boolean(localeConfig.displayLocalisedReviewSize)
  const initialTabName = pdpProductSizeGuides[0]?.tabName ?? ''
  const [activePdpProductSizeGuide, setActivePdpProductSizeGuide] = useState(initialTabName)
  const [activeSizeGuideUnitIndex, setActiveSizeGuideUnitIndex] = useState(() =>
    showLocalisedReviewUI ? getDefaultUnitIndex(pdpProductSizeGuides, initialTabName) : 0,
  )

  const handlePdpProductSizeGuideChange = (tabName: string) => {
    setActivePdpProductSizeGuide(tabName)
    if (showLocalisedReviewUI) {
      setActiveSizeGuideUnitIndex(getDefaultUnitIndex(pdpProductSizeGuides, tabName))
    }
  }

  const handleUnitsChange = (index: number) => {
    setActiveSizeGuideUnitIndex(index)
  }

  return {
    activeSizeGuideUnitIndex,
    handleUnitsChange,
    activePdpProductSizeGuide,
    handlePdpProductSizeGuideChange,
  }
}

export { useSizeGuide }
